import { combineReducers } from "@reduxjs/toolkit";
import mainSlice from "./slice/main.slice";
import kypSlice from "./slice/kyp.slice";
import recommendationSlice from "./slice/recommendation.slice";

const rootReducer = combineReducers({ mainSlice, kypSlice, recommendationSlice });

export default rootReducer;
